<span class="label">Enter URL:</span>
<input type="text" [(ngModel)]="value" data-formula="e=mc^2">
<a class="btn-insert" (click)="popupRef.close(value)">Insert</a>
